import { SelectPrimitive as e, selectChipVariants as t, selectDescriptionVariants as n, selectItemVariants as r, selectTriggerVariants as i } from "./select-primitive.js";
import { SelectChips as a, SelectContent as o, SelectDrawerFooter as s, SelectGroup as c, SelectGroupLabel as l, SelectInput as u, SelectList as d, SelectOption as f, SelectRoot as p, SelectTrigger as m } from "./select.js";
import { SelectGroup as h, selectGroupAddonVariants as g, selectGroupVariants as _ } from "./select-group.js";
//#region src/select/index.ts
var v = Object.assign(p, {
	Root: p,
	Label: e.Label,
	Description: e.Description,
	Error: e.Error,
	Trigger: m,
	Field: e.Field,
	Value: e.Value,
	Icon: e.Icon,
	Content: o,
	List: d,
	Option: f,
	Item: e.Item,
	ItemText: e.ItemText,
	ItemIndicator: e.ItemIndicator,
	Empty: e.Empty,
	Group: c,
	GroupLabel: l,
	Separator: e.Separator,
	Chips: a,
	Chip: e.Chip,
	ChipRemove: e.ChipRemove,
	OverflowBadge: e.OverflowBadge,
	LeadingIcon: e.LeadingIcon,
	ItemCheckbox: e.ItemCheckbox,
	Clear: e.Clear,
	Input: u,
	DrawerFooter: s
});
//#endregion
export { v as Select, h as SelectGroup, e as SelectPrimitive, t as selectChipVariants, n as selectDescriptionVariants, g as selectGroupAddonVariants, _ as selectGroupVariants, r as selectItemVariants, i as selectTriggerVariants };
